import { memo, lazy, Suspense } from 'react';

// Bundle splitting utilities
export const lazyLoad = (componentImport, fallback) => {
  const LazyComponent = lazy(componentImport);

  const LazyWrapper = memo(props => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  ));

  LazyWrapper.displayName = 'LazyWrapper';
  return LazyWrapper;
};
